import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './Reducers';

const logger = createLogger({
  // diff: true,
  duration: true,
  timestamp: true,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: gDM => gDM().concat(logger),
});

// export const { dispatch } = store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
